import { RequiredMarkText } from '@components/required/styles';
import * as React from 'react';

interface IProps {
    className?: string;
    mark?: React.ReactNode;
}

export const RequiredMark: React.FunctionComponent<IProps> = (
    {
        className,
        mark = '*'
    }
) => {
    return (
        <RequiredMarkText className={className}
                          aria-hidden={true}>
            {mark}
        </RequiredMarkText>
    );
};



// WEBPACK FOOTER //
// ./src/components/required/mark.tsx